import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    target: "_blank",
    rel: "noopener",
    class: _normalizeClass(_ctx.linkClass)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}